import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=4ba7cf30&scoped=true&"
import script from "./NewPage.vue?vue&type=script&lang=js&"
export * from "./NewPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPage.vue?vue&type=style&index=0&id=4ba7cf30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7cf30",
  null
  
)

export default component.exports